"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleSliderBulletWrapper = exports.ArticleSlideWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ArticleSlideWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__ArticleSlideWrapper",
  componentId: "sc-qbk3gq-0"
})(["overflow:hidden;li{list-style:none;}.article-slide-content{display:flex;}.article-slide-card{position:relative;}"]);
exports.ArticleSlideWrapper = ArticleSlideWrapper;
var ArticleSliderBulletWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__ArticleSliderBulletWrapper",
  componentId: "sc-qbk3gq-1"
})([".bullet-list{display:flex;padding:0;li{list-style:none;padding-left:0;font-size:1.5em;margin:0 10px;width:15px;}.bullet-clickable{cursor:pointer;}}"]);
exports.ArticleSliderBulletWrapper = ArticleSliderBulletWrapper;